<template>
  <div>
    <locationnetworks
      :locationnetworks="locationNetworks"
      :isloading="isLoading"
      @locationNetworkSaved="fetchLocationNetworks()"
    ></locationnetworks>
    <div>
    </div>
    
  </div>
</template>
      <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
<script>
import Api from "@/services/Api";
import format from "date-fns/format";
import LocationNetworks from "@/components/LocationNetworks.vue";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  components: {
    locationnetworks: LocationNetworks,
    loading: Loading
  },
  data() {
    return {
      locationNetworks: [],
      isLoading: true
    };
  },
  computed: {},
  async created() {
        this.initialize();
  },

  methods: {
    fetchLocationNetworks() {
      this.isLoading=true
      Api()
        .get("/locationNetworks/basic/active")
        .then(async response => {
          this.locationNetworks = response.data
          this.isLoading=false;
        });
    },
    initialize() {
      this.fetchLocationNetworks();
    }
  }
};
</script>
